var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"width":"100%","color":"primary","padless":"","marginless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }